import React, { useEffect, useState } from "react";
import { Clock, Play } from "lucide-react";
import { Card, CardContent } from "../../../misc/Card";
import { getVideoList } from "../getVideoList";
import { Link } from "react-router-dom";

interface TutorialListProps {
    type: string;
}

const TutorialList: React.FC<TutorialListProps> = ({ type }) => {
    const [tutorials, setTutorials] = useState(getVideoList(type) || []);

    useEffect(() => {
        const videoList = getVideoList(type);
        if (videoList) {
            setTutorials(videoList);
        }
    }, [type]);

    return (
        <div className="space-y-4">
            <div className="flex items-center justify-between">
                <h2 className="text-xl font-bold text-gray-900">
                    Tutorial Series
                </h2>
            </div>
            <div className="space-y-3">
                {tutorials.map((tutorial) => (
                    <Link to={tutorial.link}>
                        <Card
                            key={tutorial.id}
                            className={`overflow-hidden cursor-pointer transition-all hover:ring-2 hover:ring-offset-2 hover:ring-gray-200 ${
                                tutorial.active
                                    ? "ring-2 ring-offset-2 ring-secondary"
                                    : ""
                            }`}
                        >
                            <CardContent className="p-0">
                                <div className="flex flex-row items-center">
                                    <div className="relative w-24 h-16 sm:w-32 sm:h-20 flex-shrink-0">
                                        <img
                                            src={
                                                tutorial.thumbnail ||
                                                "/placeholder.svg"
                                            }
                                            alt={tutorial.title}
                                            className="object-cover"
                                        />
                                        {!tutorial.active && (
                                            <div className="absolute inset-0 flex items-center justify-center bg-black/50">
                                                <Play className="h-6 w-6 text-white" />
                                            </div>
                                        )}
                                    </div>
                                    <div className="p-3 flex-1">
                                        <h3 className="font-medium text-sm sm:text-base text-gray-900 line-clamp-2">
                                            {tutorial.title}
                                        </h3>
                                        <div className="flex items-center mt-1 text-xs text-gray-500">
                                            <Clock className="h-3 w-3 mr-1" />
                                            <span>{tutorial.duration}</span>
                                        </div>
                                    </div>
                                </div>
                            </CardContent>
                        </Card>
                    </Link>
                ))}
            </div>
        </div>
    );
};

export default TutorialList;
